const DpoCoreSmazaniZadosti = {
    init: function() {
        let tlacitko = $("#tlacitkoSmazatZadostZadatel");
        if (!tlacitko.length) {
            tlacitko = $("#tlacitkoSmazatZadostAdmin");
        }

        if (!tlacitko.length) {
            return;
        }

        tlacitko
            .off('click')
            .on('click', function(e) {
                e.preventDefault();
                if (tlacitko.hasClass("disabled")) {
                    return;
                }
                tlacitko.attr("disabled", true).prop("disabled", true);

                let text = '<p class="text text-center font-weight-bold">';
                text += "Opravdu si přejete smazat žádost?";
                text += "</p>";
                text += '<div class="text-center">';
                text += '<i class="fa fa-exclamation-triangle fa-fw fa-5x mt-3 mb-4 text-danger"></i>';
                text += "</div>";
                text += "<p class='text text-center'>";
                text += "";
                text += "</p>";

                WilleModal.setTitle('Smazání žádosti');
                WilleModal.disableClose();
                WilleModal.setContent(text);
                WilleModal.addButton('delete', '<i class="fas fa-fw fa-file-pdf"></i> Smazat', 'btn btn-danger', function() {
                    DpoCoreSmazaniZadosti.smazZadost();
                    DpoCoreSmazaniZadosti.promiseClose(tlacitko);
                });
                WilleModal.addButton('cancel', '<i class="fas fa-fw fa-times"></i> ' + translate('Close'), 'btn btn-secondary', function() {
                    DpoCoreSmazaniZadosti.promiseClose(tlacitko);
                });
                WilleModal.build(null);
            });
    },

    promiseClose: function (tlacitko) {
        Promise.all([
            WilleModal.close()
        ]).then(() => {
            tlacitko.attr("disabled", false).prop("disabled", false);
        }).catch((messages) => {
            console.log(messages);
        });
    },

    smazZadost: function() {
        let url = window.location.protocol + "//" + window.location.host;
        url += "/ajax/core/smazatZadost";

        const sekceId = $('#idSection').val();
        if (!sekceId) {
            return;
        }
        url += '/' + sekceId;

        const zadostId = $('#idItem').val();
        if (zadostId) {
            url += '/' + zadostId;
        }

        const _ch = $("#_ch");
        if (!_ch.length) {
            return;
        }

        $.ajax({
            type: "post",
            url: url,
            data: {"_ch": _ch.val()},
            dataType: "json",
            global: true,
            beforeSend: function () {
                Lemo_Alert.closeAll();
            },
            success: function (r) {
                if (r.hasOwnProperty("messages")) {
                    Lemo_Alert.addMany(r["messages"]);
                }
                if (r.hasOwnProperty("status") && true === r.status) {
                    setTimeout(function () {
                        url = window.location.protocol + "//" + window.location.host;
                        url += "/section/zadosti/item/"
                        window.location = url;
                    }, 2000);
                }
            }
        });
    }
}

$(document).ready(function () {
    DpoCoreSmazaniZadosti.init();
});
